import { render, staticRenderFns } from "./ProductsTab.vue?vue&type=template&id=746e95c2"
import script from "./ProductsTab.vue?vue&type=script&lang=js"
export * from "./ProductsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports